import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { uint8ArrayToBase64 } from '../lib/crypto/oprf/helpers';

type CryptoStore = {
  clientSalt: string | null;
  setClientSalt: (clientSalt: Uint8Array<ArrayBuffer>) => void;
  clear: () => void;
};

export const useCryptoStore = create(
  persist<CryptoStore>(
    (set) => ({
      clientSalt: null,
      setClientSalt: (clientSalt: Uint8Array) =>
        set({ clientSalt: uint8ArrayToBase64(clientSalt) }),
      clear: () => set({ clientSalt: null }),
    }),
    {
      name: 'crypto-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
